import React from "react";
import { Row, Col, Modal, Button, notification } from "antd";
import styles from "./GroceryModals.module.scss";
import textStyles from "../../Shared/Styles/TextStyles.module.scss";
import { deleteTempGroceryCart } from "../../../services/GroceryService";
import { CartDeleteAction } from "../../../types/GroceryTypes";
import { useGroceryCtx } from "../../../context/GroceryContext";

type Props = {
  personId: number;
  isVisible: boolean;
  setVisibility: Function;
  handleUpdateDeliveryAddress: Function;
};

function ChangeDeliveryAddressWarningModal({
  personId,
  isVisible,
  setVisibility,
  handleUpdateDeliveryAddress,
}: Props) {
  function handleCancel() {
    setVisibility(false);
  }

  const { cachedGroceryCartItemsCtx } = useGroceryCtx();
  const [, setCachedGroceryCartItems] = cachedGroceryCartItemsCtx;

  async function handleContinue() {
    try {
      await deleteTempGroceryCart(personId, CartDeleteAction.EmptyCartItems);

      setCachedGroceryCartItems([]);
      handleUpdateDeliveryAddress();
      setVisibility(false);
    } catch {
      notification.error({
        message: "Failed to delete items in the cart.",
      });
    }
  }

  return (
    <Modal
      visible={isVisible}
      className={styles.changeDeliveryAddressWarningModalContainer}
      centered
      footer={
        <Row justify="center" gutter={[8, 8]}>
          <Col flex={1}>
            <Button
              className={`${styles.cancelBtn} ${textStyles.normalText14}`}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Col>
          <Col flex={1}>
            <Button
              className={`${styles.continueBtn} ${textStyles.boldText14}`}
              onClick={handleContinue}
            >
              Continue
            </Button>
          </Col>
        </Row>
      }
    >
      <Row className={`${textStyles.boldText16} ${styles.marginDown8}`}>
        Change delivery address
      </Row>

      <Row className={textStyles.normalText14}>
        To change your delivery address, we'll need to empty your cart. Would
        you like to continue?
      </Row>
    </Modal>
  );
}

export default ChangeDeliveryAddressWarningModal;
